/**
 * Speed Plus tab set.
 *
 * A list of steps on the left, one panel on the right. The panels are all in
 * the document, so every step is in the HTML for a crawler to read even though
 * only one is visible at a time. Without the script the first panel shows and
 * the rest stay hidden, which is still a readable page.
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKey.bind(this));

      const start = Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
      this.select(start, false);
    }

    onClick(event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab) return;
      event.preventDefault();
      this.select(this.tabs.indexOf(tab), true);
    }

    /** Arrow keys walk the list, Home and End jump to the ends. */
    onKey(event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab) return;
      const i = this.tabs.indexOf(tab);
      let next = null;

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight': next = (i + 1) % this.tabs.length; break;
        case 'ArrowUp':
        case 'ArrowLeft': next = (i - 1 + this.tabs.length) % this.tabs.length; break;
        case 'Home': next = 0; break;
        case 'End': next = this.tabs.length - 1; break;
        default: return;
      }

      event.preventDefault();
      this.select(next, true);
      this.tabs[next].focus();
    }

    select(index, animate) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-active', on);
      });

      this.panels.forEach((panel, i) => {
        const on = i === index;
        panel.hidden = !on;
        if (on && animate && !REDUCED.matches) {
          panel.classList.remove('is-entering');
          // Reflow so the class re-triggers the transition on every switch.
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
    }
  }

  if (!customElements.get('sp-tabs')) customElements.define('sp-tabs', SpTabs);
})();
